import { render, staticRenderFns } from "./StaffDetails.vue?vue&type=template&id=92a1488c&scoped=true"
import script from "./StaffDetails.vue?vue&type=script&lang=js"
export * from "./StaffDetails.vue?vue&type=script&lang=js"
import style0 from "./StaffDetails.vue?vue&type=style&index=0&id=92a1488c&prod&scoped=true&lang=css"
import style1 from "./StaffDetails.vue?vue&type=style&index=1&id=92a1488c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a1488c",
  null
  
)

export default component.exports